import { create } from "zustand";
import type { Coordinate } from "../../entities/tracking";
import type { PickedLocation } from "./types";
import type { LocationPickerOptions } from "./types";

// Demande de sélection en cours. `pick()` en pose une, `LocationPickerHost` la
// rend en surcouche, et la confirmation la résout.
//
// ## Pourquoi un store et non plus une simple navigation
// La version précédente ouvrait le sélecteur avec `navigate("/location-picker")`
// et gardait le resolver dans une variable de module. Sur web, changer de route
// DÉMONTE l'écran appelant : au retour, le composeur de course se remontait avec
// un état neuf et réécrasait l'adresse choisie par la position GPS en cache. Le
// point sélectionné n'arrivait jamais à destination — le `setDelivery` de la
// promesse s'appliquait à une instance déjà détruite.
//
// En surcouche, l'appelant ne quitte jamais l'écran : la promesse se résout dans
// un composant vivant, et tout son état (articles, arrêts, contacts) survit.
//
// Le resolver vit dans le store plutôt que dans un module à part : une demande
// ouverte et le moyen de la clore sont une seule et même chose, les séparer
// permettait de fermer sans résoudre — l'appelant restait alors sur un `await`
// éternel.

export type LocationPickerRequest = {
  initial?: Coordinate | null;
  title?: string;
  presentation?: LocationPickerOptions["presentation"];
  resolve: (result: PickedLocation | null) => void;
};

type LocationPickerState = {
  request: LocationPickerRequest | null;
  open: (request: LocationPickerRequest) => void;
  close: (result: PickedLocation | null) => void;
};

export const useLocationPickerStore = create<LocationPickerState>((set, get) => ({
  request: null,

  open: (request) => {
    // Une demande précédente encore ouverte (cas limite : double clic) est close
    // à `null`, sans quoi son appelant attendrait indéfiniment.
    get().request?.resolve(null);
    set({ request });
  },

  close: (result) => {
    const { request } = get();
    if (!request) return;
    set({ request: null });
    request.resolve(result);
  },
}));
